// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"da9a1048","239":"c5e099fa","732":"38af96f3"}[chunkId] + ".chunk.js";
};